import React from 'react';
import PropTypes from 'prop-types'
class HeadPart extends React.Component{
    constructor(props,context){
        super(props,context)
    }
    static propTypes={
        style:PropTypes.object,
        className:PropTypes.string,
        name:PropTypes.string,
        title:PropTypes.string,
    }
    render(){
        let {style,className,name,title}=this.props;
        style={
            height:'100%',
            ...style
        }
        return <div style={style} className={className} title={title}>
            {name}
        </div>
    }
}
export default HeadPart;